import z from "zod";

export const pathEnum = z.enum(["AVS", "RETAIL", "SYSTEM"]);

export const actionTypeEnum = z.enum([
  "CONNECTION",
  "DISCONNECTION",
  "KVPS_CHANGE",
  "VEHICLE_SEARCH_INIT",
  "DRAFT_CREATE",
  "DRAFT_UPDATE",
  "DRAFT_DELETE",
  "CTM_VALIDATION",
]);

export const resultEnum = z.enum(["OK", "KO_METIER", "KO_TECH"]);

export const getActivityLogListRequestSchema = z.object({
  dateFrom: z.string().optional().nullable(),
  dateTo: z.string().optional().nullable(),
  path: pathEnum.optional().nullable(),
  kvps: z.string().optional().nullable(),
  actionType: actionTypeEnum.optional().nullable(),
  result: resultEnum.optional().nullable(),
  q: z.string().optional().nullable(),
  p: z.coerce.number().int().positive().default(1),
  s: z.coerce.number().int().positive().default(10),
});
